import { BITCOIN_APP_CONFIG } from "../../config/api";
import { BehaviorSubject } from "rxjs";
import { ExternalLinkEnum } from "../../shared/bitcoin-app/enums/external-link.enum";
import { isAndroid, isMobile } from 'mobile-device-detect';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../loader.service";
var BitcoinAppService = /** @class */ (function () {
    function BitcoinAppService(http, loaderService) {
        this.http = http;
        this.loaderService = loaderService;
        this.config = BITCOIN_APP_CONFIG;
        this.iframeVisibility = new BehaviorSubject(null);
        this.updateBalance = new BehaviorSubject(null);
    }
    BitcoinAppService.prototype.getCheckoutUrl = function (aiStyleId, amount, aiTypeImageGeneration, keywords) {
        this.loaderService.show();
        return this.http.post(this.config.getCheckoutUrl, { aiStyleId: aiStyleId, amount: amount, aiTypeImageGeneration: aiTypeImageGeneration, keywords: keywords });
    };
    BitcoinAppService.prototype.getWithdrawUrl = function (amount) {
        this.loaderService.show();
        return this.http.post(this.config.getWithdrawUrl, { amount: amount });
    };
    BitcoinAppService.prototype.isWithdrawBitcoinSessionExist = function () {
        this.loaderService.show();
        return this.http.post(this.config.isWithdrawCryptoSessionExist, {});
    };
    BitcoinAppService.prototype.isCryptoCheckoutSessionExist = function (shortName) {
        this.loaderService.show();
        return this.http.post(this.config.isCheckoutCryptoSessionExist, { shortName: shortName });
    };
    BitcoinAppService.prototype.getCryptoWithdrawUrl = function (amount, shortName) {
        this.loaderService.show();
        return this.http.post(this.config.getCryptoWithdrawUrl, { amount: amount, shortName: shortName });
    };
    BitcoinAppService.prototype.isCryptoWithdrawSessionExist = function (shortName) {
        this.loaderService.show();
        return this.http.post(this.config.isWithdrawCryptoSessionExist, { shortName: shortName });
    };
    BitcoinAppService.prototype.cryptoGenerateImages = function (aiStyleId, aiTypeImageGeneration, keywords) {
        this.loaderService.show();
        return this.http.post(this.config.cryptoGenerateImages, { aiStyleId: aiStyleId, aiTypeImageGeneration: aiTypeImageGeneration, keywords: keywords });
    };
    BitcoinAppService.prototype.hideIframe = function () {
        this.iframeVisibility.next({ show: false, src: '' });
    };
    BitcoinAppService.prototype.showIframe = function (src, shortName) {
        this.iframeVisibility.next({ show: true, src: src, shortName: shortName });
    };
    BitcoinAppService.prototype.requestBalanceUpdating = function () {
        this.updateBalance.next(Math.random());
        this.updateBalance.next(null);
    };
    BitcoinAppService.prototype.openPaypal = function () {
        this.checkAndOpenApp(ExternalLinkEnum.paypalWebUrl);
    };
    BitcoinAppService.prototype.checkAndOpenApp = function (fallbackUrl) {
        var deepLink = isAndroid ? ExternalLinkEnum.paypalDeepLinkAndroid : ExternalLinkEnum.paypalDeepLink;
        if (isMobile) {
            this.openUrl({ url: deepLink });
        }
        else {
            window.open(fallbackUrl, '_system'); // Use _system for opening in external browser/store
        }
    };
    BitcoinAppService.prototype.openUrl = function (options) {
        window.open(options.url, '_blank');
        return true;
    };
    BitcoinAppService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function BitcoinAppService_Factory() { return new BitcoinAppService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.LoaderService)); }, token: BitcoinAppService, providedIn: "root" });
    return BitcoinAppService;
}());
export { BitcoinAppService };
